import media from 'common-ui-components/src/vtj/theme/media'
import fonts from 'common-ui-components/src/vtj/theme/fonts'
import variables from 'common-ui-components/src/vtj/theme/variables'

export const h1 = `
    font-family: ${fonts.lightFont};
    margin-bottom: 16px;
    font-size: 32px;
    line-height: 38px;
    ${media.desktop}{
        font-size: 40px;
        line-height: 48px;
    }
`

export const h2 = `
    font-family: ${fonts.semiBoldFont};
    margin-bottom: 16px;
    font-size: 26px;
    line-height: 32px;
    ${media.desktop}{
        font-size: 28px;
        line-height: 34px;
    }
`

export const h3 = `
    font-family: ${fonts.semiBoldFont};
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 26px;
    ${media.desktop}{
        font-size: 22px;
        line-height: 28px;
    }
`

export const h4 = `
    font-family: ${fonts.semiBoldFont};
    margin-bottom: 8px;
    font-size: ${variables.fontSize}px;
    line-height: 20px;
    ${media.desktop}{
        font-size: 18px;
        line-height: 24px;
    }
`

export const responsiveBaseTextSizes = `
    font-size: ${variables.smallFontSize}px;
    ${media.desktop}{
        font-size: ${variables.fontSize}px;
    }
`

export const p = `
    font-family: ${fonts.bodyFont};
    margin-bottom: 1em;
    line-height: ${variables.textLineHeight}em;
    ${responsiveBaseTextSizes}
`
